import { Dialog } from '@mui/material';

interface CustomFullScreenStageInterface {
  onClose: () => void;
  open: boolean;
  generalStageVideoElement: JSX.Element;
  menuComponentElement: JSX.Element;
}

const CustomFullScreenStage = ({ open, generalStageVideoElement, menuComponentElement, onClose }: CustomFullScreenStageInterface) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: { backgroundColor: 'black', height: '100vh', width: '100cqw' } }}
      componentsProps={{ root: { style: { background: 'black', display: 'flex', flexDirection: 'column', justifyContent: 'center' } } }}
      fullScreen>
      <div className="relative h-full">
        <div className="transform h-screen w-auto">{generalStageVideoElement}</div>
        <div className="absolute top-0 right-4 z-10 mt-24 opacity-20 hover:opacity-100 transition-opacity">{menuComponentElement}</div>
      </div>
    </Dialog>
  );
};
export default CustomFullScreenStage;
